module.exports = __webpack_public_path__ + "static/img/news8.2048383.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/news/news8.jpg
// module id = 8J/r
// module chunks = 1